import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import UserContextProvider from './Context/Auth/UserContextProvider';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import NotCompatibleScreen from './Pages/NotCompatibleScreen';
ReactDOM.render(
  <React.StrictMode>
    {
      isMobile ?
        <>
          <NotCompatibleScreen />
        </>
        :
        <>
          <UserContextProvider>
            <App />
          </UserContextProvider>
        </>
    }
  </React.StrictMode>,
  // document.getElementById('root')
  document.body
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
